<template>
  <van-button type="info" size="small" v-show="showUpToTopBtn" class="goTop" icon="arrow-up" @click="backTop">回到顶部</van-button>
</template>

<script>
export default {
  data () {
    return {
      showUpToTopBtn: false// 是否显示回到顶部按钮
    }
  },
  mounted () {
    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop () {
      document.documentElement.scrollTop = 0
    },
    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop () {
      const that = this
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 200) {
        that.showUpToTopBtn = true
      } else {
        that.showUpToTopBtn = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.goTop {
  position: fixed;
  right: 20px;
  bottom: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/scrollToTop.vue